import {
  FORM_PROPERTY_TYPE_ENDPAGE,
  FORM_PROPERTY_TYPE_ENDPAGE_REDIRECT
} from '../constants/formPropertyTypes'
import { LANGUAGES } from '../constants/languages'


export const createSimpleProperty = (key, value) => {
  return key ? { [key]: value } : null
}

export const createTranslatedProperty = (key, value, language = LANGUAGES.default) => {
  return key ? { [key]: { [language]: value }} : null
}

export const createTranslatedProperties = (propertyName, value, translatedValues, language) => {
  return {
    translatedValues: {
      ...translatedValues,
      [propertyName]: { [language]: value }
    }
  }
}

export const getPredefinedSelections = (field) => {
  const predefinedSelections = field?.options
    ?.filter(option => !!getSimpleProperty(option, 'defaultChecked'))
    ?.map(o => o.id)
  return predefinedSelections.length > 0 ? predefinedSelections : null
}

export const getRedirectUrlIfEnabled = form => {
  const { mode, url } = getSimpleProperty(form, FORM_PROPERTY_TYPE_ENDPAGE) || {}
  return mode === FORM_PROPERTY_TYPE_ENDPAGE_REDIRECT ? url : ''
}

export const getSimpleProperty = (container, key) =>  {
  return container?.simpleValues?.[key]
}

export const getTranslatedProperties = (data, language) => {
  if (!data) return {}
  let properties = { ...data.translatedValues }
  Object.keys(properties).forEach(propertyName => {
    properties[propertyName] = properties[propertyName][language]
  })
  return properties
}

export const getTranslatedProperty = (container, key, language) => {
  return container?.translatedValues?.[key]?.[language]
}

export const getValidationProperty = (container, key) => {
  return container?.validations?.find(validation => validation.validationName === key)
}

export const isPropertyEnabled = (question, key) => {
  const propertySetting = getSimpleProperty(question, key) || {}
  return propertySetting?.enabled === true
}

// Will mutate the container passed in
export const updateSimpleProperty = (container, key, value) => {
  if (!container.simpleValues) {
    container.simpleValues = {}
  }

  const oldValue = container.simpleValues[key]
  if (value === null) {
    delete container.simpleValues[key]
  } else if (typeof oldValue === 'object' && oldValue !== null) {
    container.simpleValues[key] = {
      ...oldValue,
      ...value
    }
  } else {
    container.simpleValues[key] = value
  }
}

// Will mutate the container passed in
export const updateTranslatedProperty = (container, key, value, language) => {
  if (!container.translatedValues) {
    container.translatedValues = {}
  }

  if (!container.translatedValues[key]) {
    container.translatedValues[key] = {}
  }

  container.translatedValues[key][language] = value
}

export const getPropertyValueByPlanFeature = (value, defaultValue, shouldCheckIfEnabled, isEnabled) => {
  return shouldCheckIfEnabled ? isEnabled ? value : defaultValue : value
}
